/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SizeValidationType {
    MIN = 'MIN',
    MAX = 'MAX',
}
